/**
 * Copy text to the clipboard. Falls back to execCommand when the
 * Clipboard API is missing or blocked (HTTP, Headless UI focus trap).
 */
export async function copyTextToClipboard(text) {
  const value = String(text ?? "");

  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return;
    } catch {
      // Dialogs and non-secure origins often reject writeText.
    }
  }

  const textarea = document.createElement("textarea");
  textarea.value = value;
  textarea.setAttribute("readonly", "");
  textarea.setAttribute("aria-hidden", "true");
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "0";
  textarea.style.width = "1px";
  textarea.style.height = "1px";
  textarea.style.padding = "0";
  textarea.style.border = "none";
  textarea.style.outline = "none";
  textarea.style.boxShadow = "none";
  textarea.style.background = "transparent";
  textarea.style.opacity = "0";

  const root =
    document.activeElement?.closest('[role="dialog"]') ||
    document.querySelector('[role="dialog"]') ||
    document.body;
  root.appendChild(textarea);
  textarea.focus({ preventScroll: true });
  textarea.select();
  textarea.setSelectionRange(0, value.length);

  let ok = false;
  try {
    ok = document.execCommand("copy");
  } finally {
    root.removeChild(textarea);
  }

  if (!ok) {
    throw new Error("copy_failed");
  }
}
